<template>
    <b-modal
        id="modal-confirm-auto-void-return-kas-kecil"
        centered
        :no-close-on-backdrop="isSubmitting"
        :no-close-on-esc="isSubmitting"
        :hide-header-close="isSubmitting"
        title="Konfirmasi Pengembalian Dana"
    >
        <p class="mb-2">
            Apakah Anda yakin ingin memproses pengembalian dana ini? Dana pengembalian akan otomatis dibuatkan kas masuk!
        </p>
        <b-form id="autoVoidReturnReasonForm" @submit.prevent="$emit('submit')">
            <b-form-group label="Keterangan (opsional)" class="mb-0">
                <b-form-textarea
                    :value="reason"
                    name="autoVoidReturnReason"
                    rows="3"
                    maxlength="255"
                    @input="$emit('update:reason', $event)"
                />
                <small class="text-muted">{{ reason.length }}/255</small>
            </b-form-group>
        </b-form>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="secondary" :disabled="isSubmitting" @click="cancel()">
                Batal
            </b-button>
            <b-button
                variant="pgiBtn"
                type="submit"
                form="autoVoidReturnReasonForm"
                :disabled="isSubmitting"
                name="autoVoidConfirmReturnSubmitBtn"
            >
                <b-spinner v-if="isSubmitting" small class="mr-1" />
                Konfirmasi
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "modal-kas-kecil-confirm-auto-void-return",
    props: {
        isSubmitting: { type: Boolean, default: false },
        reason: { type: String, default: "" },
    },
}
</script>
